module.exports = __webpack_public_path__ + "static/media/Microsoft Surface Pro 4.14ed651c.png";